import { Component, OnInit } from '@angular/core';
import { Location, UpperCasePipe } from "@angular/common";
import {GlobalService} from "../../../services/global.service";
import {GlobalManagerFigliService} from "../../../services/global-manager-figli.service";
import {LoaderService} from "../../../services/loader.service";
import {ManageErrorService} from "../../../services/manage-error.service";
import {NotificationService} from "../../../services/notification.service";
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {ModalRoleEnum} from "../../enums/modal-enum";
import { IonToolbar, IonTitle, IonLabel, IonRadioGroup, IonItem, IonRadio, IonGrid, IonRow, IonCol, IonButton, ModalController } from '@ionic/angular/standalone';
import {Studente} from "../../../../api-clients/generated/services";

@Component({
    selector: 'app-choose-child-modal',
    templateUrl: './choose-child-modal.component.html',
    styleUrls: ['./choose-child-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonRadioGroup, IonItem, IonRadio, IonGrid, IonRow, IonCol, IonButton, FormsModule, ReactiveFormsModule, UpperCasePipe]
})
export class ChooseChildModalComponent  implements OnInit {

  opzioniFigli: Array<Studente>;
  currentStudente: Studente | undefined;
  modalTitle: string = 'Seleziona Studente';
  ctrlStudente = new FormControl<Studente | null | undefined>(null);
  confirmButtonText = 'Conferma';
  cancelButtonText = 'Annulla'
  modalMessage = 'Scegli una delle seguenti opzioni';

  constructor(private location: Location,
              private globalService: GlobalService,
              private managerFigli: GlobalManagerFigliService,
              private loaderService: LoaderService,
              private manageErrorService: ManageErrorService,
              private notificationService: NotificationService,
              private modalController: ModalController) {
    this.opzioniFigli = this.managerFigli.opzioniStudenti;
    this.currentStudente = this.managerFigli.currentStudente;
    this.ctrlStudente.setValue(this.currentStudente);
    this.ctrlStudente.setValidators(Validators.required);
    this.ctrlStudente.updateValueAndValidity({emitEvent: false})
  }

  ngOnInit() {

  }
  cancel() {
    return this.modalController.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirm() {
    if(this.ctrlStudente.valid) {
      this.managerFigli.setCurrentStudente(this.ctrlStudente.value!)
    }
    return this.modalController.dismiss(null, ModalRoleEnum.CONFIRM);
  }
}
